/**
 * 市场三菜单渠道动态化公共逻辑。
 * 使用方需提供：bizType / listUrl / insertUrl / updateUrl / deleteUrl / pageTitle
 */
export default {
  data () {
    return {
      searchLoading: false,
      tableLoading: false,
      saveLoading: false,
      showModal: false,
      showChannelModal: false,
      showChannelEdit: false,
      channelLoading: false,
      channelSaving: false,
      totalCount: 0,
      enabledChannels: [],
      allChannels: [],
      queryParam: {
        period: '',
        personName: '',
        pageIndex: 1,
        pageSize: 200
      },
      formData: {
        id: null,
        period: '',
        personName: '',
        channelValues: {}
      },
      channelForm: {
        id: null,
        displayName: '',
        channelKey: '',
        sort: null
      },
      dataList: [],
      baseColumns: []
    }
  },
  computed: {
    columns () {
      const self = this
      const cols = [
        {title: '周期', key: 'period', minWidth: 120},
        {title: '姓名', key: 'personName', minWidth: 100}
      ]
      const channels = this.enabledChannels || []
      if (!channels.length) {
        cols.push({
          title: '渠道',
          minWidth: 160,
          render: (h) => h('span', {style: {color: '#999'}}, '请先在渠道管理中添加渠道')
        })
      } else {
        channels.forEach(ch => {
          const key = ch.channelKey
          cols.push({
            title: ch.displayName,
            key: key,
            width: 90,
            render: (h, params) => {
              const map = self.parseValues(params.row)
              const v = map[key]
              return h('span', v == null || v === '' ? '' : v)
            }
          })
        })
      }
      cols.push({title: '总计', key: 'total', width: 80})
      cols.push({
        title: '操作人',
        minWidth: 100,
        render: (h, params) => {
          if (params.row._isSum) return h('span', '')
          return h('span', params.row.modifierName || params.row.creatorName || '')
        }
      })
      cols.push({
        title: '操作时间',
        minWidth: 160,
        render: (h, params) => {
          if (params.row._isSum) return h('span', '')
          return h('span', params.row.gmtModified || params.row.gmtCreate || '')
        }
      })
      cols.push({
        title: '操作',
        width: 140,
        fixed: 'right',
        render: (h, params) => {
          if (params.row._isSum) return h('span', '')
          return h('div', [
            h('Button', {
              props: {type: 'primary', size: 'small'},
              style: {marginRight: '6px'},
              on: {click: function () { self.openEdit(params.row) }}
            }, '编辑'),
            h('Button', {
              props: {type: 'error', size: 'small'},
              on: {click: function () { self.remove(params.row) }}
            }, '删除')
          ])
        }
      })
      return cols
    },
    channelColumns () {
      const self = this
      return [
        {title: '展示名', key: 'displayName', minWidth: 120},
        {
          title: '标识',
          key: 'channelKey',
          minWidth: 120,
          render: (h, params) => h('span', {style: {color: '#888', fontSize: '12px'}}, params.row.channelKey)
        },
        {title: '排序', key: 'sort', width: 80},
        {
          title: '状态',
          width: 90,
          render: (h, params) => {
            const on = params.row.status === 1
            return h('Tag', {props: {color: on ? 'green' : 'default'}}, on ? '启用' : '禁用')
          }
        },
        {
          title: '操作',
          width: 200,
          render: (h, params) => {
            const on = params.row.status === 1
            const btns = [
              h('Button', {
                props: {type: 'text', size: 'small'},
                on: {click: function () { self.openRename(params.row) }}
              }, '改名')
            ]
            btns.push(h('Button', {
              props: {type: 'text', size: 'small'},
              on: {
                click: function () {
                  self.toggleStatus(params.row, on ? 0 : 1)
                }
              }
            }, on ? '禁用' : '启用'))
            btns.push(h('Button', {
              props: {type: 'text', size: 'small'},
              style: {color: '#ed4014'},
              on: {click: function () { self.deleteChannel(params.row) }}
            }, '删除'))
            return h('div', btns)
          }
        }
      ]
    },
    tableDataWithSum () {
      const list = this.dataList || []
      if (!list.length) return list
      const sumRow = {_isSum: true, period: '总计', personName: '', _values: {}}
      let totalSum = 0
      let totalHas = false
      ;(this.enabledChannels || []).forEach(ch => {
        let s = 0
        let has = false
        list.forEach(r => {
          const map = this.parseValues(r)
          const v = map[ch.channelKey]
          if (v != null && v !== '') {
            s += Number(v) || 0
            has = true
          }
        })
        sumRow[ch.channelKey] = has ? s : ''
        sumRow._values[ch.channelKey] = has ? s : null
      })
      list.forEach(r => {
        if (r.total != null && r.total !== '') {
          totalSum += Number(r.total) || 0
          totalHas = true
        }
      })
      sumRow.total = totalHas ? totalSum : ''
      return list.concat([sumRow])
    }
  },
  created () {
    this.reloadChannelsAndList()
  },
  methods: {
    parseValues (row) {
      if (!row) return {}
      if (row._values) return row._values
      if (row.channelValues && typeof row.channelValues === 'object') {
        return row.channelValues
      }
      if (typeof row.channelValues === 'string' && row.channelValues) {
        try {
          return JSON.parse(row.channelValues) || {}
        } catch (e) {
          return {}
        }
      }
      return {}
    },
    reloadChannelsAndList () {
      const self = this
      this.loadEnabledChannels().then(function () {
        self.search()
      })
    },
    loadEnabledChannels () {
      const self = this
      return this.$http.post('/marketMetricChannel/listEnabled', {bizType: this.bizType}).then(function (res) {
        if (res && res.status === 'ok') {
          self.enabledChannels = res.data || []
        } else {
          self.enabledChannels = []
        }
      }).catch(function () {
        self.enabledChannels = []
      })
    },
    loadAllChannels () {
      const self = this
      this.channelLoading = true
      return this.$http.post('/marketMetricChannel/list', {bizType: this.bizType}).then(function (res) {
        self.channelLoading = false
        if (res && res.status === 'ok') {
          self.allChannels = res.data || []
        }
      }).catch(function () {
        self.channelLoading = false
      })
    },
    search () {
      this.searchLoading = true
      this.tableLoading = true
      this.queryParam.pageIndex = 1
      this.loadList()
    },
    loadList () {
      const self = this
      this.$http.post(this.listUrl, self.queryParam).then(function (res) {
        self.searchLoading = false
        self.tableLoading = false
        if (res && res.status === 'ok' && res.data) {
          self.dataList = res.data.data || []
          self.totalCount = res.data.totalCount || 0
        }
      }).catch(function () {
        self.searchLoading = false
        self.tableLoading = false
      })
    },
    onPageChange (page) {
      this.queryParam.pageIndex = page
      this.tableLoading = true
      this.loadList()
    },
    onPageSizeChange (size) {
      this.queryParam.pageSize = size
      this.queryParam.pageIndex = 1
      this.tableLoading = true
      this.loadList()
    },
    emptyChannelValues () {
      const map = {}
      ;(this.enabledChannels || []).forEach(ch => {
        map[ch.channelKey] = null
      })
      return map
    },
    openAdd () {
      if (!(this.enabledChannels || []).length) {
        this.$Message.warning('请先在渠道管理中添加渠道')
        return
      }
      this.formData = {
        id: null,
        period: '',
        personName: '',
        channelValues: this.emptyChannelValues()
      }
      this.showModal = true
    },
    openEdit (row) {
      const values = Object.assign({}, this.emptyChannelValues(), this.parseValues(row))
      this.formData = {
        id: row.id,
        period: row.period,
        personName: row.personName,
        channelValues: values
      }
      this.showModal = true
    },
    save () {
      const self = this
      if (!self.formData.period || !self.formData.personName) {
        self.$Message.warning('周期和姓名不能为空')
        return
      }
      const payload = {
        id: self.formData.id,
        period: self.formData.period,
        personName: self.formData.personName,
        channelValues: JSON.stringify(self.formData.channelValues || {})
      }
      self.saveLoading = true
      const url = self.formData.id ? self.updateUrl : self.insertUrl
      this.$http.post(url, payload).then(function (res) {
        self.saveLoading = false
        if (res && res.status === 'ok') {
          self.showModal = false
          self.$Message.success('保存成功')
          self.loadList()
        }
      }).catch(function () {
        self.saveLoading = false
      })
    },
    remove (row) {
      const self = this
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定删除「' + row.personName + '」在「' + row.period + '」的记录？',
        onOk: function () {
          return self.$http.post(self.deleteUrl, {id: row.id}).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已删除')
              self.loadList()
            }
          })
        }
      })
    },
    openChannelManage () {
      this.showChannelModal = true
      this.loadAllChannels()
    },
    onChannelModalClose () {
      const self = this
      this.loadEnabledChannels().then(function () {
        self.loadList()
      })
    },
    openAddChannel () {
      this.channelForm = {id: null, displayName: '', channelKey: '', sort: null}
      this.showChannelEdit = true
    },
    openRename (row) {
      this.channelForm = {
        id: row.id,
        displayName: row.displayName,
        channelKey: row.channelKey,
        sort: row.sort
      }
      this.showChannelEdit = true
    },
    saveChannel () {
      const self = this
      if (!self.channelForm.displayName) {
        self.$Message.warning('展示名不能为空')
        return
      }
      self.channelSaving = true
      const isEdit = !!self.channelForm.id
      const url = isEdit ? '/marketMetricChannel/update' : '/marketMetricChannel/insert'
      const payload = isEdit
        ? {id: self.channelForm.id, displayName: self.channelForm.displayName, sort: self.channelForm.sort}
        : {
          bizType: self.bizType,
          displayName: self.channelForm.displayName,
          channelKey: self.channelForm.channelKey || '',
          sort: self.channelForm.sort
        }
      this.$http.post(url, payload).then(function (res) {
        self.channelSaving = false
        if (res && res.status === 'ok') {
          self.showChannelEdit = false
          self.$Message.success('保存成功')
          self.loadAllChannels()
        }
      }).catch(function () {
        self.channelSaving = false
      })
    },
    toggleStatus (row, status) {
      const self = this
      const tip = status === 0
        ? '禁用后，新录入不再显示该渠道列；历史数据保留。确定禁用？'
        : '确定启用该渠道？'
      this.$Modal.confirm({
        title: status === 0 ? '确认禁用' : '确认启用',
        content: tip,
        onOk: function () {
          return self.$http.post('/marketMetricChannel/setStatus', {id: row.id, status: status}).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success(status === 0 ? '已禁用' : '已启用')
              self.loadAllChannels()
            }
          })
        }
      })
    },
    deleteChannel (row) {
      const self = this
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定删除该渠道？仅在无任何录入数据时可删。',
        onOk: function () {
          return self.$http.post('/marketMetricChannel/delete', {id: row.id}).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已删除')
              self.loadAllChannels()
            } else if (res && res.msg) {
              self.$Message.warning(res.msg)
            }
          }).catch(function (err) {
            const msg = (err && err.msg) || (err && err.message) || '该渠道已有录入数据，请改用禁用'
            self.$Message.warning(msg)
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/market/marketChannelDynamicMixin.js